import { Sport } from '@sorare/core/src/__generated__/globalTypes';

import type { FullProps } from '@sorare/marketplace/src/searchCards/AdvancedCardSearch';
import { AdvancedCardSearch } from '@sorare/marketplace/src/searchCards/AdvancedCardSearch';

export const BaseballCardSearch = (props: Omit<FullProps, 'sport'>) => (
  <AdvancedCardSearch sport={Sport.BASEBALL} {...props} />
);
